import type { List, Record } from '@gonfalon/immutable-shim/immutableShim';

import { newAccessDeniesAction } from './newAccessDeniesAction';
import { type DeniedAccess } from './types';

type AccessesRep = Record<{
  accesses: Array<{
    [key: string]: {
      denied: List<DeniedAccess>;
    };
  }>;
}>;

export function accessResponseDeniesUpdateTags(
  accesses: AccessesRep,
  newResourceSpec: string,
  oldAccessDenied: List<DeniedAccess>,
) {
  const newAccessDenied = accesses.getIn(['accesses', newResourceSpec, 'denied']);
  return newAccessDenied ? newAccessDeniesAction(oldAccessDenied, newAccessDenied, 'updateTags') : false;
}
